import { defineStore } from 'pinia';
import * as topicService from '@/services/topicService';

export const useTopicStore = defineStore('topic', {
  state: () => ({
    topics: [],
    selectedTopicIds: [],
    selectedTopic: null, // 🔥 NOVO: Armazena o detalhado para o Modal
    idTopic: null,
    error: null,
    totalCount: 0,
    totalPages: 1,
    currentPage: 1,
    pageSize: 10,
    searchTerm: '',
    shouldForcePageOne: false
  }),

  getters: {
    isAllSelected: (state) => (total) => {
      return state.selectedTopicIds.length === total;
    }
  },

  actions: {
    setIdTopic(id) {
      this.idTopic = id;
    },

    toggleSelection(id) {
      const index = this.selectedTopicIds.indexOf(id);
      if (index > -1) {
        this.selectedTopicIds.splice(index, 1);
      } else {
        this.selectedTopicIds.push(id);
      }
    },

    selectAll(ids) {
      this.selectedTopicIds = [...ids];
    },

    clearSelection() {
      this.selectedTopicIds = [];
    },

    // 🔥 NOVO: Limpa o assunto selecionado
    clearSelectedTopic() {
      this.selectedTopic = null;
    },

    async fetchTopics() {
      try {
        const response = await topicService.fetchTopics();
        this.topics = response.data;
      } catch (error) {
        this.error = error.response?.data || error.message;
        console.error("❌ Erro ao buscar assuntos:", this.error);
      }
    },

    async fetchTopicsPaged(pageNumber, pageSize, search) {
      try {
        const response = await topicService.fetchTopicsPaged(pageNumber, pageSize, search);
        this.topics = response.data.data;
        this.totalCount = response.data.totalCount;
        this.totalPages = response.data.totalPages;
        this.currentPage = pageNumber;
      } catch (error) {
        const mensagem = error.response?.data || error.message;
        this.error = mensagem;
        console.error("❌ Erro ao buscar assuntos paginados:", mensagem);
        throw new Error(mensagem);
      }
    },

    setSearchTerm(term) {
      this.searchTerm = term;
      this.currentPage = 1;
      this.shouldForcePageOne = true;
      this.fetchTopicsPaged(1, this.pageSize, term);
    },

    async getTopicById(id) {
      try {
        const response = await topicService.getTopicById(id);
        // 🔥 CRÍTICO: Salva no estado para o computed do Modal carregar fotos/nomes
        this.selectedTopic = response.data; 
        return response.data;
      } catch (error) {
        const mensagem = error.response?.data || error.message;
        console.error("❌ Erro ao obter assunto:", mensagem);
        throw new Error(mensagem);
      }
    },

    async createTopic(data, useElastic = false) {
      try {
        const response = await topicService.createTopic(data, useElastic);
        this.shouldForcePageOne = true;
        await this.fetchTopicsPaged(1, this.pageSize, this.searchTerm);
        return response.data;
      } catch (error) {
        console.error("❌ Erro ao cadastrar na store:", error.response?.data || error.message);
        throw error;
      }
    },

    async updateTopic(data, useElastic = false) {
      try {
        await topicService.updateTopic(data, useElastic);
        
        // Atualiza na lista local
        const index = this.topics.findIndex(
          (f) => f.topicId === data.topicId
        );
        if (index !== -1) {
          this.topics[index] = { ...this.topics[index], ...data };
        }

        // 🔥 Atualiza também o selectedTopic se for o mesmo que está sendo editado
        if (this.selectedTopic && this.selectedTopic.topicId === data.topicId) {
            this.selectedTopic = { ...this.selectedTopic, ...data };
        }
      } catch (error) {
        console.error("❌ Erro ao atualizar assunto:", error.mensagem);
        throw error;
      }
    },

    async deleteTopicById(id, useElastic = false) {
      try {
        await topicService.deleteTopic(id, useElastic);
        await this.fetchTopicsPaged(this.currentPage, this.pageSize, this.searchTerm);
        if (this.topics.length === 0 && this.currentPage > 1) {
          this.currentPage -= 1;
          await this.fetchTopicsPaged(this.currentPage, this.pageSize, this.searchTerm);
        }
      } catch (error) {
        const mensagem = error.response?.data.message || error.message;
        console.error("❌ Erro ao excluir assunto:", mensagem);
        throw new Error(mensagem);
      }
    },

    async deleteSelectedTopics(useElastic = false) {
      if (!this.selectedTopicIds.length) return;

      try {
        await topicService.deleteTopicsBatch(this.selectedTopicIds, useElastic);
        this.clearSelection();
        await this.fetchTopicsPaged(this.currentPage, this.pageSize, this.searchTerm);
        if (this.topics.length === 0 && this.currentPage > 1) {
          this.currentPage -= 1;
          await this.fetchTopicsPaged(this.currentPage, this.pageSize, this.searchTerm);
        }
      } catch (error) {
        const mensagem = error.response?.data.message || error.message;
        console.error("❌ Erro ao excluir em lote:", mensagem);
        throw new Error(mensagem);
      }
    }
  }
});